import {FetcherServerError, FetcherNetworkError, FetcherError} from '../fetcherErrors';
import {AbstractFetcher, FetcherParams} from '../AbstractFetcher';
import {EventBus} from '@/common/helpers/utils/EventBus';

type PostData = null | string | Record<string, any> | Blob | FormData;

export class BrowserFetcher extends AbstractFetcher {
	readonly onResponse = new EventBus<XMLHttpRequest>();

	async fetch<TResponse = any>(url: string, postData: PostData = null, params: Partial<FetcherParams> = {}) {
		return new Promise<TResponse>((resolve, reject) => {
			// Prepare the request params
			const {method, headers, postData: preparedPostData} = this.prepareParams(postData, params);

			const xhr = new XMLHttpRequest();
			xhr.open(method, url, true);

			// Set custom headers
			if (headers) {
				for (const [name, value] of Object.entries(headers)) {
					xhr.setRequestHeader(name, value);
				}
			}

			// Handle success response received
			xhr.onload = () => {
				// Parse response body
				const contentType = xhr.getResponseHeader('Content-Type') || '';
				const isJSON = contentType.toLowerCase().includes('application/json');
				let response;
				try {
					response = isJSON ? JSON.parse(xhr.responseText) : xhr.responseText;
				} catch (error) {
					response = {error: 'unknown'};
				}

				// Report a regular server error
				if (isJSON && response.error) {
					const error = new FetcherServerError(response.error, url, response);
					reject(error);
					return;
				}

				// Report a unknown server error
				if (xhr.status < 200 || xhr.status > 299) {
					const error = new FetcherError(`Status code is not okay: ${xhr.status}`, url);
					reject(error);
					return;
				}

				// Report success
				resolve(response);

				this.onResponse.emit(xhr);
			};

			// Handle HTTPS request error
			xhr.onerror = () => {
				const error = new FetcherNetworkError(url);
				reject(error);
			};

			// Submit the request
			xhr.send(preparedPostData);
		});
	}
}
